import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class UserService {

	constructor() {
	}

	public getInitials(fullName: string | null | undefined): string | null | undefined {
		if (!fullName) return '??';
		const nameParts = fullName.trim().split(' ');
		return nameParts[0].slice(0, Math.min(1, this.getMin(nameParts[0]))) + nameParts[nameParts.length - 1].slice(0, this.getMin(nameParts[nameParts.length - 1]));
	}

	private getMin(namePart: string) {
		return Math.min(1, namePart.length);
	}
}